<template>
  <div class="dialog_container">
    <el-dialog
      title="新增车辆信息"
      :visible="dialogShow"
      width="1288px"
      @close="dialogClose"
      top="5vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="addForm"
          class="add_staff_form"
          :model="addForm"
          label-width="130px"
          :rules="addRules"
        >
          <el-form-item label="车牌号码：" prop="carNumber">
            <el-input
              v-model="addForm.carNumber"
              placeholder="请输入车牌号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色：" prop="carColor">
            <el-select v-model="addForm.carColor" placeholder="请选择车牌颜色">
              <el-option
                v-for="item in carColorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-select v-model="addForm.carType" placeholder="请选择车辆类型">
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆营运性质：" prop="carService">
            <el-select
              v-model="addForm.carService"
              placeholder="请选择车辆营运性质"
            >
              <el-option
                v-for="item in carServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车架号VIN：" prop="vin">
            <el-input
              v-model="addForm.vin"
              placeholder="请输入车架号VIN"
            ></el-input>
          </el-form-item>
          <el-form-item label="燃油类型：">
            <el-select v-model="addForm.fuelType" placeholder="请选择燃油类型">
              <el-option
                v-for="item in fuelTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆厂牌：">
            <el-input
              v-model="addForm.carFactory"
              placeholder="请输入车辆厂牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆型号：">
            <el-input
              v-model="addForm.carModel"
              placeholder="请输入车辆型号"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="轴距：">
              <el-input
                class="short_ipt"
                v-model="addForm.wheelbase"
                placeholder="请输入轴距"
              ></el-input>
              <div class="unit">mm</div>
            </el-form-item>
          </div>
          <div class="flex_box">
            <el-form-item label="长：" class="min_form-item">
              <el-input class="min_ipt" v-model="addForm.carLength"></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="宽：" class="min_form-item">
              <el-input class="min_ipt" v-model="addForm.carWidth"></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="高：" class="min_form-item">
              <el-input class="min_ipt" v-model="addForm.carHigh"></el-input>
              <div class="mm_text">mm</div>
            </el-form-item>
          </div>
          <el-form-item label="发动机号：">
            <el-input
              v-model="addForm.engineSn"
              placeholder="请输入发动机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="核定座位数：">
            <el-input
              v-model="addForm.approvedPerson"
              placeholder="请输入核定座位数"
            ></el-input>
          </el-form-item>
          <el-form-item label="车轴数：">
            <el-input
              v-model="addForm.axleNum"
              placeholder="请输入车轴数"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="满载总质量：" prop="fullyLaden">
              <el-input
                class="short_ipt"
                v-model="addForm.fullyLaden"
                placeholder="请输入满载总质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="准牵引总质量：">
              <el-input
                class="short_ipt"
                v-model="addForm.tractionMass"
                placeholder="请输入准牵引总质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="核定载质量：">
              <el-input
                class="short_ipt"
                v-model="addForm.approvedLaden"
                placeholder="请输入核定载质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="整备质量：">
              <el-input
                class="short_ipt"
                v-model="addForm.curbWeight"
                placeholder="请输入整备质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>

          <el-form-item label="所属企业：">
            <el-input
              v-model="addForm.companyName"
              placeholder="请输入所属企业"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="行驶证初领日期：" prop="driverTimeStr">
            <el-date-picker
              v-model="addForm.driverTimeStr"
              type="date"
              placeholder="请选择行驶证初领日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="行驶证有效期：">
            <el-date-picker
              v-model="addForm.driverEndTimeStr"
              type="date"
              placeholder="请选择行驶证有效期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车辆登记证号：">
            <el-input
              v-model="addForm.carRegisterNumber"
              placeholder="请输入车辆登记证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆状态：">
            <el-radio-group v-model="addForm.carState">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="2">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发动机型号：">
            <el-input
              v-model="addForm.engineModel"
              placeholder="请输入发动机型号"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="发动机功率：">
              <el-input
                class="short_ipt"
                v-model="addForm.enginePower"
                placeholder="请输入发动机功率"
              ></el-input>
              <div class="unit">kw</div>
            </el-form-item>
          </div>
          <el-form-item label="登记证发证日期：">
            <el-date-picker
              v-model="addForm.registerTimeStr"
              type="date"
              placeholder="请选择登记证发证日期"
            >
            </el-date-picker>
          </el-form-item>

          <div class="form_title">车辆道路运输证信息</div>
          <el-form-item label="道路运输证：">
            <el-input
              v-model="addForm.roadTransportNumber"
              placeholder="请输入道路运输证"
            ></el-input>
          </el-form-item>
          <el-form-item label="发证机构：">
            <el-input
              v-model="addForm.roadOrgStr"
              placeholder="请输入道路发证机构"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件状态：">
            <el-radio-group v-model="addForm.roadState">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="2">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="初领日期：">
            <el-date-picker
              v-model="addForm.roadTimeStr"
              type="date"
              placeholder="请选择道路运输证初领日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="start_end_date">
            <el-form-item label="有效期：">
              <template>
                <div class="issue_time">
                  <el-date-picker
                    type="date"
                    placeholder="选择开始时间"
                    v-model="addForm.roadStartTimeStr"
                    style="width: 100%"
                  ></el-date-picker>
                  <span class="zhi_text">至</span>
                  <el-date-picker
                    type="date"
                    placeholder="选择结束时间"
                    v-model="addForm.roadEndTimeStr"
                    style="width: 100%"
                  ></el-date-picker>
                </div>
              </template>
            </el-form-item>
          </div>
        </el-form>

        <div class="form_title">挂车信息</div>
        <el-form
          ref="form"
          class="add_staff_form"
          :model="addForm"
          label-width="130px"
        >
          <el-form-item label="挂车车牌：">
            <el-input
              v-model="addForm.trailerCarNumber"
              placeholder="请输入挂车车牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆营运性质：">
            <el-select
              v-model="addForm.trailerCarService"
              placeholder="请选择挂车车辆营运性质"
            >
              <el-option
                v-for="item in carServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆厂牌：">
            <el-input
              v-model="addForm.trailerLabel"
              placeholder="请输入挂车车辆厂牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="车架号VIN：">
            <el-input
              v-model="addForm.trailerVin"
              placeholder="请输入挂车车架号VIN"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="核定载质量：" prop="fullyLaden">
              <el-input
                class="short_ipt"
                v-model="addForm.trailerApprovedLaden"
                placeholder="请输入挂车核定载质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <el-form-item label="道路许可证：">
            <el-input
              v-model="addForm.trailerLicense"
              placeholder="请选择挂车道路许可证"
            ></el-input>
          </el-form-item>

        <div class="form_title">从业人员信息</div>
          <el-form-item label="姓名：">
            <el-select v-model="addForm.driverId1" placeholder="请选择人员1" @change="driverChange1">
              <el-option
                v-for="item in driverList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位类别：">
            <el-input
              v-model="addForm.postName1"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              v-model="addForm.driverPhone1"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-select v-model="addForm.driverId2" placeholder="请选择人员2" @change="driverChange2">
              <el-option
                v-for="item in driverList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位类别：">
            <el-input
              v-model="addForm.postName2"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              v-model="addForm.driverPhone2"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>

        <div class="form_title">其他</div>
          <el-form-item label="备注：" class="textarea_form">
            <el-input
              type="textarea"
              :rows="3"
              v-model="addForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('addForm')">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      addForm: {
        carState:1,
        resource:1
      },
      addRules:{
        carNumber:[
          { required: true, message: "请输入车牌号码", trigger: "blur" },
        ],
        carColor: [
          { required: true, message: "请选择车牌颜色", trigger: "change" },
        ],
        carService: [
          { required: true, message: "请选择车辆营运性质", trigger: "change" },
        ],
        vin:[
          { required: true, message: "请输入车架号VIN", trigger: "blur" },
        ],
        fullyLaden:[
          { required: true, message: "请输入满载总质量", trigger: "blur" },
        ],
        driverTimeStr:[
          { required: true, message: "请选择行驶证初领日期", trigger: "change" },
        ],
      },
      receiveList: [],
      carColorList: [], // 车辆颜色
      carTypeList: [], // 营运性质
      carServiceList: [], // 车辆类型
      fuelTypeList: [], // 燃油类型
      roadOrgList:[], // 发证机构
      driverList:[], // 驾驶员下拉数据
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogShow(val) {
      if (val) {
        let userInfo =  JSON.parse(sessionStorage.getItem("userInfo"));
        this.addForm.companyName = userInfo.username;
        this.addForm.companyId = userInfo.userId;
        console.log(this.addForm);
        this.$http.getSelect(1).then((res) => {
          if (res.code == 0) {
            this.carColorList = res.data;
          } else {
            this.carColorList = [];
          }
        });
        this.$http.getSelect(2).then((res) => {
          if (res.code == 0) {
            this.carServiceList = res.data;
            this.carTypeList = res.data; // 车辆类型 暂时无接口 先暂用 营运类型的数据
          } else {
            this.carServiceList = [];
          }
        });
        this.$http.getSelect(3).then((res) => {
          if (res.code == 0) {
            this.fuelTypeList = res.data;
          } else {
            this.fuelTypeList = [];
          }
        });
        this.$http.getSelect(4).then((res) => {
          if (res.code == 0) {
            this.roadOrgList = res.data;
          } else {
            this.roadOrgList = [];
          }
        });
        this.$http.getDriverList().then(res=>{
            if (res.code == 0) {
            this.driverList = res.data;
          } else {
            this.driverList = [];
          }
        })
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      if (this.addForm.wheelbase) {
        if (
          typeof (this.addForm.wheelbase * 1) == "number" &&
          isNaN(this.addForm.wheelbase * 1)
        ) {
          this.$message.error("轴距只能是数字");
          return;
        }
      }
      if (
        this.addForm.carLength ||
        this.addForm.carWidth ||
        this.addForm.carHigh
      ) {
        if (
          (typeof (this.addForm.carLength * 1) == "number" &&
            isNaN(this.addForm.carLength * 1)) ||
          (typeof (this.addForm.carWidth * 1) == "number" &&
            isNaN(this.addForm.carWidth * 1)) ||
          (typeof (this.addForm.carHigh * 1) == "number" &&
            isNaN(this.addForm.carHigh * 1))
        ) {
          this.$message.error("长宽高只能是数字");
          return;
        }
      }
      if (this.addForm.approvedPerson) {
        if (
          typeof (this.addForm.approvedPerson * 1) == "number" &&
          isNaN(this.addForm.approvedPerson * 1)
        ) {
          this.$message.error("核定座位数只能是数字");
          return;
        }
      }

      if (this.addForm.axleNum) {
        if (
          typeof (this.addForm.axleNum * 1) == "number" &&
          isNaN(this.addForm.axleNum * 1)
        ) {
          this.$message.error("车轴数只能是数字");
          return;
        }
      }

      if (this.addForm.fullyLaden) {
        if (
          typeof (this.addForm.fullyLaden * 1) == "number" &&
          isNaN(this.addForm.fullyLaden * 1)
        ) {
          this.$message.error("满载总质量只能是数字");
          return;
        }
      }

      if (this.addForm.tractionMass) {
        if (
          typeof (this.addForm.tractionMass * 1) == "number" &&
          isNaN(this.addForm.tractionMass * 1)
        ) {
          this.$message.error("准牵引总质量只能是数字");
          return;
        }
      }
      if (this.addForm.approvedLaden) {
        if (
          typeof (this.addForm.approvedLaden * 1) == "number" &&
          isNaN(this.addForm.approvedLaden * 1)
        ) {
          this.$message.error("核定载质量只能是数字");
          return;
        }
      }
      if (this.addForm.curbWeight) {
        if (
          typeof (this.addForm.curbWeight * 1) == "number" &&
          isNaN(this.addForm.curbWeight * 1)
        ) {
          this.$message.error("整备质量只能是数字");
          return;
        }
      }
      if (this.addForm.trailerApprovedLaden) {
        if (
          typeof (this.addForm.trailerApprovedLaden * 1) == "number" &&
          isNaN(this.addForm.trailerApprovedLaden * 1)
        ) {
          this.$message.error("挂车核定载质量只能是数字");
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if(this.addForm.driverTimeStr){
            this.addForm.driverTimeStr = dateTransition(this.addForm.driverTimeStr)
        }
        if(this.addForm.driverEndTimeStr){
            this.addForm.driverEndTimeStr = dateTransition(this.addForm.driverEndTimeStr)
        }
        if(this.addForm.registerTimeStr){
            this.addForm.registerTimeStr = dateTransition(this.addForm.registerTimeStr)
        }
        if(this.addForm.roadTimeStr){
            this.addForm.roadTimeStr = dateTransition(this.addForm.roadTimeStr)
        }
        if(this.addForm.roadStartTimeStr){
            this.addForm.roadStartTimeStr = dateTransition(this.addForm.roadStartTimeStr)
        }
        if(this.addForm.roadEndTimeStr){
            this.addForm.roadEndTimeStr = dateTransition(this.addForm.roadEndTimeStr)
        }
        this.$http.addCarInfo(this.addForm).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg)
            this.$parent.getList();
            this.$emit("update:dialogShow", false);
            this.addForm = {}
          }else{
            this.$message.error(res.msg)
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    driverChange1(e){
        this.driverList.forEach(i=>{
            if(i.id === e){
                this.addForm.postName1 = i.postStr
                this.addForm.driverPhone1 = i.phone
            }
        })
    },
    driverChange2(e){
        this.driverList.forEach(i=>{
            if(i.id === e){
                this.addForm.postName2 = i.postStr
                this.addForm.driverPhone2 = i.phone
            }
        })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.textarea_form{
    width: 100%;
    height: 66px;
    /deep/.el-form-item__content{
        width: calc(100% - 130px)!important;
    } 
}
/deep/.el-dialog__body{
    max-height: 70vh;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carInfo_component/addCar.vue